import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AdminLayout.css';

const navItems = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: '📊' },
  { to: '/admin/materials', label: 'Materials', icon: '🧱' },
  { to: '/admin/categories', label: 'Categories', icon: '📁' },
  { to: '/admin/orders', label: 'Orders', icon: '📦' },
  { to: '/admin/customers', label: 'Customers', icon: '👥' },
  { to: '/admin/enquiries', label: 'Enquiries', icon: '💬' },
  { to: '/admin/reviews', label: 'Reviews', icon: '⭐' },
  { to: '/admin/coupons', label: 'Coupons', icon: '🎟️' },
  { to: '/admin/banners', label: 'Banners', icon: '🖼️' },
  { to: '/admin/users', label: 'Users', icon: '👤' },
  { to: '/admin/settings', label: 'Settings', icon: '⚙️' }
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-brand">
          <span className="admin-sidebar-logo">DesignOps</span>
          <span className="admin-sidebar-badge">Admin</span>
        </div>
        <nav className="admin-sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `admin-nav-link ${isActive ? 'admin-nav-link--active' : ''}`
              }
              end={item.to === '/admin/dashboard'}
            >
              <span className="admin-nav-icon">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="admin-sidebar-footer">
          <button
            type="button"
            className="admin-sidebar-logout"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </aside>
      <div className="admin-main">
        <header className="admin-header">
          <h1 className="admin-header-title">Admin Panel</h1>
          <div className="admin-header-user">
            <span className="admin-header-email">{user?.email}</span>
          </div>
        </header>
        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
